import Vue from 'Vue'

const eventBus = new Vue()

export { eventBus }



// WEBPACK FOOTER //
// ./src/assets/js/eventBus.js